export const BaseLineMessage = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M12 4V2" stroke="currentColor" strokeLinecap="round" strokeWidth="1.5" />
    <path
      d="M12.0003 4C15.3171 4 18.0059 6.57436 18.0059 9.75V14.25L18.0088 14.4245C18.0499 15.6462 18.5213 16.8792 19.4053 18.1196V18.1196C19.4447 18.1738 19.406 18.2499 19.339 18.2499H4.66206C4.59474 18.2499 4.55594 18.1734 4.59568 18.1191V18.1191C5.52134 16.8201 5.99462 15.5288 5.99462 14.25V9.75C5.99462 6.57436 8.68344 4 12.0003 4Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M15 18.5C15 20.1569 13.6569 21.5 12 21.5C10.3431 21.5 9 20.1569 9 18.5"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);
